export default {"src":"/_next/static/media/mail.80325442.svg","height":11,"width":15,"blurWidth":0,"blurHeight":0};